var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlackboardChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 38,
    viewBox: "0 0 38 38",
    width: 38,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-5 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h48v48h-48z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15 26.5h18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 26.5v-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 26.5v-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 42-2-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 42 2-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.85 34.0000001h-27.7-.0000002c-2.29197998 0-4.14999998-1.8580181-4.14999998-4.1500001v-19.7.0000006c0-2.29197997 1.858018-4.15000047 4.14999998-4.15000047h27.698.0000002c2.29198-.00110398 4.1509 1.8560185 4.1519998 4.14800047v.0020005 19.698-.0000265c.0011198 2.29198-1.8559913 4.1509-4.1479793 4.1520255-.0006668 0-.0013336 0-.0020004 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 26.5v-6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackboardChart);
export default __webpack_public_path__ + "static/media/blackboard-chart.0ddaef3caa3bdde65f4a5fa788ad93ac.svg";
export { ForwardRef as ReactComponent };